import { useState } from "react";
import { IoCloseOutline, IoCloudUploadSharp } from "react-icons/io5";
import * as D from "assets/iconsSVG/documentIcon";
import { RiDeleteBin6Line } from "react-icons/ri";
import { useCadastrarPropostaManual } from "services/api/SimuladorRepasseAssociativo/post-cadastrar-proposta-manual";
import MaterialUI from "material-UI";
import { useParams } from "react-router-dom";
import * as S from "./styles";

interface Props {
  onClose: () => void;
}

const ACCEPTED_EXTENSIONS = [".xlsx", ".xls", ".csv"];

const ModalPropostaManual = ({ onClose }: Props) => {
  const [uploadedFile, setUploadedFile] = useState<File | null>(null);
  const params: any = useParams();

  const {
    mutate: mutateCadastrarPropostaManual,
    isLoading: isLoadingCadastrarPropostaManual,
  } = useCadastrarPropostaManual();

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];
      const extension = `.${file.name.split(".").pop()?.toLowerCase()}`;
      if (!ACCEPTED_EXTENSIONS.includes(extension)) {
        return;
      }
      setUploadedFile(file);
    }
  };

  const handleSendFile = () => {
    if (uploadedFile) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const base64 = e.target?.result;
        mutateCadastrarPropostaManual(
          {
            idLeadCorretor: params.idLeadCorretor,
            idUnidade: params.idUnidade,
            anexo: {
              base64: (base64 as string).split(",").pop() as string,
              fileName: uploadedFile.name,
            },
          },
          {
            onSuccess: (data) => {
              onClose();
              localStorage.setItem(
                "leadTabData",
                JSON.stringify({
                  idLeadCorretor: params.idLeadCorretor,
                  tabValue: 1,
                })
              );
              window.location.pathname = `/lead-detail/${params.idLeadCorretor}/proposition-detail/${data?.data?.numeroCotacao}`;
            },
          }
        );
      };
      reader.readAsDataURL(uploadedFile);
    }
  };

  const handleRemoveFile = () => {
    setUploadedFile(null);
  };

  return (
    <S.Content>
      <S.Header>
        <S.Row style={{ justifyContent: "space-between" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <D.DocumentIcon />
            <S.TextTitle>Proposta Manual - Upload de Excel</S.TextTitle>
          </div>
          <S.CloseButton onClick={onClose}>
            <IoCloseOutline size={32} />
          </S.CloseButton>
        </S.Row>
      </S.Header>
      <S.SpaceY space={8} />
      <S.Body>
        {!uploadedFile ? (
          <label htmlFor="file-upload-proposta-manual">
            <S.ContentRowCutted>
              <IoCloudUploadSharp size={24} color="#999999" />
              <S.TextDescription>
                Carregar arquivo Excel (.xlsx, .xls, .csv)
              </S.TextDescription>
            </S.ContentRowCutted>
            <input
              id="file-upload-proposta-manual"
              type="file"
              accept=".xlsx,.xls,.csv"
              style={{ display: "none" }}
              onChange={handleFileChange}
            />
          </label>
        ) : (
          <>
            <S.ContentDocument>
              <S.TextUpload>Documento</S.TextUpload>
            </S.ContentDocument>
            <S.SpaceY space={8} />
            <S.ContentInfoDocument>
              <S.TextUpload>{uploadedFile.name}</S.TextUpload>
              <S.DeleteButton onClick={handleRemoveFile}>
                <RiDeleteBin6Line size={24} color="#ff4d4f" />
              </S.DeleteButton>
            </S.ContentInfoDocument>
            <S.SpaceY space={8} />
            <S.ContentRowCuttedNoAction>
              <IoCloudUploadSharp size={24} color="#999999" />
              <S.TextDescription>Você já carregou um arquivo</S.TextDescription>
            </S.ContentRowCuttedNoAction>
          </>
        )}
        <S.SpaceY space={32} />
        <S.SaveButton
          onClick={handleSendFile}
          disabled={!uploadedFile || isLoadingCadastrarPropostaManual}
        >
          {isLoadingCadastrarPropostaManual ? (
            <MaterialUI.CircularProgress
              size={22}
              style={{ color: "#ffffff" }}
            />
          ) : (
            "Enviar"
          )}
        </S.SaveButton>
      </S.Body>
    </S.Content>
  );
};

export default ModalPropostaManual;
